(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
  const showcaseSlider = new Swiper(".home-showcaseSlider", {
  speed: 1000,
  slidesPerView: 1,
  parallax: true,
  // centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".showcaseSlider-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: '.showcaseSlider-next',
    prevEl: '.showcaseSlider-prev',
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  /* CART COUNT */
  const cartEl = document.getElementById('cart-count');
  if (cartEl) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(c => {
        if (c.item_count > 0) {
          cartEl.textContent = c.item_count;
          cartEl.hidden = false;
        }
      });
  }

});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-xb-wishlist-open]');
  if (!btn) return;

  e.preventDefault();

  // XB Wishlist popup button auto-detected
  const xbBtn =
    document.querySelector('[data-xb-wishlist-popup]') ||
    document.querySelector('.xb-wishlist-open') ||
    document.querySelector('[class*="xb-wishlist"] button');

  if (xbBtn) {
    xbBtn.click();
  }
});

document.addEventListener('DOMContentLoaded', function () {

  const COUNT_SELECTOR = '[data-xb-wishlist-count]';

  function getWishlistCount() {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      if (key && key.toLowerCase().includes('xb') && key.toLowerCase().includes('wishlist')) {
        try {
          const data = JSON.parse(localStorage.getItem(key));
          if (Array.isArray(data)) return data.length;
        } catch (e) {}
      }
    }
    return 0;
  }

  function updateWishlistCount() {
    const el = document.querySelector(COUNT_SELECTOR);
    if (!el) return;

    const count = getWishlistCount();

    if (count > 0) {
      el.textContent = count;
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', true);
    }
  }

  /* ===============================
     🔥 HOOK localStorage.setItem
     =============================== */
  const originalSetItem = localStorage.setItem;
  localStorage.setItem = function () {
    originalSetItem.apply(this, arguments);

    const key = arguments[0];
    if (!key || !key.toLowerCase().includes('wishlist')) return;

    // 🧠 XB remove is async → wait properly
    Promise.resolve().then(() => {
      requestAnimationFrame(updateWishlistCount);
    });
  };

  // Initial
  updateWishlistCount();

  // Safety fallback
  setInterval(updateWishlistCount, 2000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
(function () {
  const grid = document.getElementById('wishlist-grid');
  const empty = document.getElementById('wishlist-empty');

  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  if (!wishlist.length) {
    empty.hidden = false;
    return;
  }

  wishlist.forEach(handle => {
    fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(product => {
        const item = document.createElement('div');
        item.className = 'wishlist-item';

        item.innerHTML = `
          <a href="${product.url}">
            <img src="${product.featured_image}" alt="${product.title}">
            <p>${product.title}</p>
            <p>${Shopify.formatMoney(product.price)}</p>
          </a>
          <button class="wishlist-remove">Remove</button>
        `;

        item.querySelector('.wishlist-remove').onclick = () => {
          const updated = wishlist.filter(h => h !== handle);
          localStorage.setItem('wishlist', JSON.stringify(updated));
          location.reload();
        };

        grid.appendChild(item);
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
